import vm from "../main";
import axios from "./PointrCloudAxios";
import ToastHelpers from "@/helpers/ToastHelpers";

export default class SiteService {
  static async getSites(clientInternalIdentifier) {
    let response;
    let sites;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.get(`/content/draft/clients/${clientInternalIdentifier}/sites`);
    } catch (error) {
      console.error(error);
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    const geojson = response?.data;
    if (geojson) {
      sites = geojson?.features?.filter((feature) => feature.properties.typeCode === "site-outline");
      sites = sites.map((site) => {
        site.properties.buildings = geojson?.features?.filter(
          (feature) =>
            feature.properties.typeCode === "building-outline" && feature.properties.sid === site.properties.fid
        );
        site.properties.buildings = site.properties.buildings.map((building, index) => {
          building.properties.levels = geojson?.features?.filter(
            (feature) =>
              feature.properties.typeCode === "level-outline" && feature.properties.bid === building.properties.fid
          );
          building.properties.mapId = index;
          return building;
        });
        return site;
      }); // sort sites by name
      return sites;
    }
    return undefined;
  }

  static async getSite(clientInternalIdentifier, siteInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.get(`/content/draft/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}`);
    } catch (error) {
      console.error(error);
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    let site;
    const geojson = response?.data;
    if (geojson) {
      site = geojson?.features?.find((feature) => feature.properties.typeCode === "site-outline");
      // sort sites by name
      return site;
    }
    return undefined;
  }

  static async createSite(site, clientInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.post(`/content/draft/clients/${clientInternalIdentifier}/sites`, site);
    } catch (error) {
      console.error(error);
      ToastHelpers.createServiceErrorToast(
        error?.response?.data,
        error?.response?.data?.message || `${vm.$t("contents.fail-message")}`
      );
      throw error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    ToastHelpers.createSuccessToast(`${site.features[0].properties.name} ${vm.$t("contents.created")}`);
    return response.data;
  }

  static async updateSite(site, clientInternalIdentifier, siteInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.put(
        `/content/draft/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}`,
        site
      );
    } catch (error) {
      console.error(error);
      ToastHelpers.createServiceErrorToast(
        error?.response?.data,
        error?.response?.data?.message || `${vm.$t("contents.fail-message")}`
      );
      throw error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    ToastHelpers.createSuccessToast(`${site.features[0].properties.name} ${vm.$t("contents.updated")}`);
    return response.data;
  }

  static async deleteSite(clientInternalIdentifier, siteInternalIdentifier) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      response = await axios.delete(
        `/content/draft/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}`
      );
    } catch (error) {
      console.error(error);
      ToastHelpers.createServiceErrorToast(
        error?.response?.data,
        error?.response?.data?.message || vm.$t(`delete-failed`)
      );
      throw error?.response?.data;
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    ToastHelpers.createSuccessToast(`Site ${vm.$t("delete-success")}`);
    return response.data;
  }

  static async getDraftSite(clientInternalIdentifier, siteInternalIdentifier, abortController = null) {
    let response;
    vm.$store.commit("ADD_LOADING_REQUEST");
    try {
      const config = abortController ? { signal: abortController.signal } : {};
      response = await axios.get(
        `/content/draft/clients/${clientInternalIdentifier}/sites/${siteInternalIdentifier}`,
        config
      );
    } catch (error) {
      if (error.name === "AbortError") {
        throw error;
      }
      console.error(error);
    } finally {
      vm.$store.commit("REMOVE_LOADING_REQUEST");
    }
    return response?.data;
  }
}
